export const HOTSTAR_URL = "https://www.hotstar.com/in/shows/bigg-boss/14714";

// Single source of truth for contestant imagery.
// For Season 10, replace only the `img` value with the image URL used by the StrawPoll option.
// Every contestant card, profile, archive surface and SEO JSON-LD entry consumes this same field.
export const CURRENT_SEASON_NUMBER = 10;
export const CURRENT_PHONE = "+918886650451";

const placeholder = (name) =>
  `https://placehold.co/720x960/101323/F5F7FF?text=${encodeURIComponent(name)}`;

const contestant = (name, profession, bio = "Bigg Boss Telugu housemate.", img = null) => ({
  id: name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  name,
  profession,
  bio,
  img: img || placeholder(name),
});

export const season10Contestants = [
  contestant("Rohit Naidu", "Digital creator & model", "A commoner entrant from the Agnipariksha selection route.", "https://cdn.strawpoll.com/images/polls/options/eJnvB2z4nv4-c.png"),
  contestant("Aman Masud", "Actor & performer", "A commoner contestant bringing a performance-driven style to the house.", "https://cdn.strawpoll.com/images/polls/options/61gDz7p5ywd-c.png"),
  contestant("Debjani Modak", "Television actress", "Actress known for work across Bengali, Tamil and Telugu television.", "https://cdn.strawpoll.com/images/polls/options/kogjw1PvZ6M-c.png"),
  contestant("Thrigun", "Film actor", "Actor competing under the Season 10 Dasavatharam format.", "https://cdn.strawpoll.com/images/polls/options/GJn4waM7yzm-c.png"),
  contestant("Srishti Vyakaranam", "Model & actor", "Model, actor and software professional who entered through the selection process.", "https://cdn.strawpoll.com/images/polls/options/Dwyov5rkZAz-c.png"),
  contestant("Shalini Damera", "Model & digital creator", "Model and digital personality with a strong social-media presence.", "https://cdn.strawpoll.com/images/polls/options/BDyN4RGkgRO-c.png"),
  contestant("Jabardasth Naresh", "Comedian & actor", "Comedian known for his work on the Jabardasth comedy platform.", "https://cdn.strawpoll.com/images/polls/options/NoZrxJONn3x-c.png"),
  contestant("Varshini Sounderajan", "Actress & television presenter", "Telugu television and film personality with experience as a presenter and model.", "https://cdn.strawpoll.com/images/polls/options/PKglQAMEZp0-c.png"),
  contestant("RJ Charan", "Radio jockey & creator", "Radio personality and digital creator who entered the Season 10 house.", "https://cdn.strawpoll.com/images/polls/options/YVyP513BnNd-c.png"),
  contestant("Singer Jhansi", "Folk singer & creator", "Folk singer, farmer and social-media creator from the Agnipariksha route.", "https://cdn.strawpoll.com/images/polls/options/bVg8NYOeyYa-c.png"),
  contestant("Temper Vamsi", "Film actor", "Film actor known for his energetic screen presence.", "https://cdn.strawpoll.com/images/polls/options/1MnwdWakg7D-c.png"),
  contestant("Auto Ram Prasad", "Comedian & actor", "Popular Telugu comedian and actor entering the house with a strong entertainment profile.", "https://cdn.strawpoll.com/images/polls/options/kjn1kJGdZQe-c.png"),
  contestant("Krishnudu", "Film actor", "Telugu film actor and one of the Season 10 housemates.", "https://cdn.strawpoll.com/images/polls/options/NPgxB72Py2r-c.png"),
  contestant("Mukesh Gowda", "Television actor & model", "Television actor and model known for Telugu serial audiences.", "https://cdn.strawpoll.com/images/polls/options/jVyGWlwYy7E-c.png"),
  contestant("Sudheer Reddy", "Anchor & digital creator", "Anchor and digital creator competing in the Season 10 house.", "https://cdn.strawpoll.com/images/polls/options/NMnQQdMWn6Y-c.png"),
  contestant("Chaitra Rai", "Television & film actress", "Actress with experience across television and cinema.", "https://cdn.strawpoll.com/images/polls/options/poy9veE2nJr-c.png"),
];

// Season archives are intentionally data-driven so the UI can later become routed SEO pages
// without changing the presentation components.
export const seasonArchives = [
  {
    number: 1, year: 2017, title: "Bigg Boss Telugu Season 1", theme: "Original", host: "Jr NTR",
    winner: "Siva Balaji", runnerUp: "Aadarsh Balakrishna", days: 71,
    contestants: [
      "Archana Shastry", "Sameer Hasan", "Mumaith Khan", "Prince Cecil", "Madhu Priya", "Jyothi", "Siva Balaji",
      "Kalpana Raghavendar", "Mahesh Kathi", "Kathi Karthika", "Sampoornesh Babu", "Aadarsh Balakrishna", "Hari Teja", "Dhanraj",
      "Diksha Panth", "Navdeep"
    ],
  },
  {
    number: 2, year: 2018, title: "Bigg Boss Telugu Season 2", theme: "Season 2", host: "Nani",
    winner: "Kaushal Manda", runnerUp: "Geetha Madhuri", days: 113,
    contestants: [
      "Geetha Madhuri", "Amit Tiwari", "Deepti Nallamothu", "Tanish Alladi", "Babu Gogineni", "Bhanu Sree", "Roll Rida",
      "Syamala", "Kireeti Damaraju", "Deepthi Sunaina", "Kaushal Manda", "Tejaswi Madivada", "Samrat Reddy", "Ganesh",
      "Sanjana Anne", "Nutan Naidu", "Nandini Rai", "Pooja Ramachandran", "Rakesh"
    ],
  },
  {
    number: 3, year: 2019, title: "Bigg Boss Telugu Season 3", theme: "Season 3", host: "Nagarjuna Akkineni",
    winner: "Rahul Sipligunj", runnerUp: "Sreemukhi", days: 106,
    contestants: [
      "Hema", "Himaja", "Jaffar Babu", "Ravi Krishna", "Ashu Reddy", "Punarnavi Bhupalam", "Shivajyothi",
      "Ali Reza", "Varun Sandesh", "Vithika Sheru", "Baba Bhaskar", "Sreemukhi", "Mahesh Vitta", "Ravi Krishna", "Rahul Sipligunj", "Tamanna Simhadri", "Shiva Jyothi"
    ],
  },
  {
    number: 4, year: 2020, title: "Bigg Boss Telugu Season 4", theme: "Season 4", host: "Nagarjuna Akkineni",
    winner: "Abhijeet Duddala", runnerUp: "Akhil Sarthak", days: 106,
    contestants: [
      "Monal Gajjar", "Surya Kiran", "Lasya Manjunath", "Abhijeet Duddala", "Jordaar Sujatha", "Mehaboob Dilse",
      "Devi Nagavalli", "Alekhya Harika", "Syed Sohail Ryan", "Ariyana Glory", "Amma Rajasekhar", "Karate Kalyani",
      "Noel Sean", "Divi Vadthya", "Akhil Sarthak", "Gangavva", "Avinash", "Swathi Deekshith", "Kumar Sai"
    ],
  },
  {
    number: 5, year: 2021, title: "Bigg Boss Telugu Season 5", theme: "Season 5", host: "Nagarjuna Akkineni",
    winner: "VJ Sunny", runnerUp: "Shanmukh Jaswanth", days: 106,
    contestants: [
      "Siri Hanmanth", "VJ Sunny", "Lahari Shari", "Sreerama Chandra", "Anee Master", "Lobo", "Shailaja Priya",
      "Nataraj", "Uma Devi", "Hamida", "Jessie", "Ravi Kiran", "Sarayu Roy", "Vishwa", "Maanas Nagulapalli",
      "Kajal Kalukuri", "Swetha Varma", "Ravi", "Priyanka Singh", "Shanmukh Jaswanth", "Anne Master"
    ],
  },
  {
    number: 6, year: 2022, title: "Bigg Boss Telugu Season 6", theme: "Season 6", host: "Nagarjuna Akkineni",
    winner: "L. V. Revanth", runnerUp: "Shrihan Shaik", days: 105,
    contestants: [
      "Keerthi Bhat", "Sudeepa Pinky", "Shrihan Shaik", "Neha Chowdary", "Chalaki Chanti", "Sri Satya", "Arjun Kalyan",
      "Geetu Royal", "Abhinaya Shree", "Marina Abraham", "Rohit Sahni", "Bala Aditya", "Vasanthi Krishnan", "Shani Salmon",
      "Inaya Sulthana", "RJ Surya", "Faima Sheikh", "Adi Reddy", "Raj Shekar", "Arohi Rao", "L. V. Revanth"
    ],
  },
  {
    number: 7, year: 2023, title: "Bigg Boss Telugu Season 7", theme: "Ulta Pulta", host: "Nagarjuna Akkineni",
    winner: "Pallavi Prashanth", runnerUp: "Amardeep Chowdary", days: 105,
    contestants: [
      "Priyanka Jain", "Sivaji", "Damini Bhatla", "Prince Yawar", "Shubha Shree", "Shakeela", "Aata Sandeep",
      "Shobha Shetty", "Tasty Teja", "Ratika Rose", "Gautham Krishna", "Kiran Rathod", "Pallavi Prashanth", "Amardeep Chowdary",
      "Nayani Pavani", "Ashwini Sri", "Bhooloka", "Pooja Murthy", "Arjun Ambati"
    ],
  },
  {
    number: 8, year: 2024, title: "Bigg Boss Telugu Season 8", theme: "Limitless", host: "Nagarjuna Akkineni",
    winner: "Nikhil Maliyakkal", runnerUp: "Gautham Krishna", days: 106,
    contestants: [
      "Yashmi Gowda", "Nikhil Maliyakkal", "Abhay Bethiganti", "Prerana Kambam", "Aditya Om", "Sonia Akula", "Bezawada Bebakka",
      "RJ Shekar Basha", "Kirrak Seetha", "Naga Manikanta", "Prithviraj Shetty", "Vishnu Priya", "Nainika Anasuru", "Nabeel Afridi",
      "Gautham Krishna", "Mehaboob Dilse", "Haritha Harish", "Avinash Karnan", "Teja M", "Rohini Noni", "Gangavva"
    ],
  },
  {
    number: 9, year: 2025, title: "Bigg Boss Telugu Season 9", theme: "Ranarangam", host: "Nagarjuna Akkineni",
    winner: "Kalyan Padala", runnerUp: "Thanuja Puttaswamy", days: 105,
    contestants: [
      "Kalyan Padala", "Thanuja Puttaswamy", "Demon Pavan", "Emmanuel", "Sanjjanaa Galrani", "Bharani Shankar", "Suman Shetty",
      "Rithu Chowdary", "Divya Nikitha", "Gaurav Gupta", "Nikhil Nair", "Sreenivasa Sayee", "Ramu Rathod", "Madhuri Duvvada",
      "Sreeja Dammu", "Ramya Moksha", "Aysha Zeenath", "Flora Saini", "Harita Harish", "Priya Shetty", "Maryada Manish", "Shrasti Verma"
    ],
  },
];

export const season9ImageMap = {
  "Demon Pavan": "https://cdn.strawpoll.com/images/polls/options/GJn4QGeqgzm-c.png",
  "Emmanuel": "https://cdn.strawpoll.com/images/polls/options/1Mnwrvq5y7D-c.png",
  "Thanuja Puttaswamy": "https://cdn.strawpoll.com/images/polls/options/wby5ole7gAe-c.png",
  "Kalyan Padala": "https://cdn.strawpoll.com/images/polls/options/NMnQJBGAg6Y-c.png",
  "Divya Nikitha": "https://cdn.strawpoll.com/images/polls/options/DwyoLqwNnAz-c.png",
  "Bharani Shankar": "https://cdn.strawpoll.com/images/polls/options/BDyNdjL7gRO-c.png",
  "Suman Shetty": "https://cdn.strawpoll.com/images/polls/options/YVyPE2BAnNd-c.png",
  "Rithu Chowdary": "https://cdn.strawpoll.com/images/polls/options/poy9KRNwgJr-c.png",
  "Nikhil Nair": "https://cdn.strawpoll.com/images/polls/options/kjn14jWAyQe-c.png",
  "Gaurav Gupta": "https://cdn.strawpoll.com/images/polls/options/eJnvR7oanv4-c.png",
  "Sanjjanaa Galrani": "https://cdn.strawpoll.com/images/polls/options/bVg8P68BgYa-c.png",
};
